<template>
    <div ref="modal" class="modal fade" :id="name" tabindex="-1" role="dialog" :aria-labelledby="name">
        <div :class="className" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">
                        <slot name="title"></slot>
                    </div>
                    <button type="button" class="close" @click="close" aria-label="Close">
                        <img src="../assets/images/icon-close.svg"/>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="confirm">
                        <slot name="body"></slot>
                        <div class="row m-auto">
                            <slot name="buttons"></slot>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  inject: ['$validator'],

  name: 'Modal',

  props: {
    name: {
      type: String,
      default: 'myModal'
    },
    size: {
      type: String,
      default: null
    }
  },

  computed: {
    className () {
      return {
        'modal-dialog': true,
        'modal-lg': this.size === 'large',
        'modal-xl': this.size === 'xl'
      }
    }
  },

  methods: {
    show () {
      this.$nextTick(() => this.$validator.reset())
      $(this.$refs.modal).modal('show')
    },

    close () {
      $(this.$refs.modal).modal('hide')
      this.errors.clear()
    },

    confirm () {
      this.$emit('confirm')
    }
  },

  mounted () {
    $(this.$refs.modal).on('hidden.bs.modal', (e) => {
      this.$emit('hidden')

      if ($('.modal.show').length) {
        $('body').addClass('modal-open')
      }
    })
  }
}
</script>
